import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';

interface VectorOutlineColorOptionProps {
  onClickColorOption(id: string): void;
  className?: string;
}

export function VectorOutlineColorOption({className = '', ...props}: VectorOutlineColorOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const solidBorderColor = useGetKeyFromBorderOfActiveItem('solidBorderColor');

  if (!activeItem || !solidBorderColor) {
    return null;
  }

  const onClickHandler = (id: string): void => {
    props.onClickColorOption(id);
  };

  const getColorFillData = (): ColorFillStorage[] => {
    return [
      {
        id: 'primary',
        color: getColorObjectArrayFromFillColor([solidBorderColor]),
        fillType: ColorFillPropertyType.SOLID,
      },
    ];
  };

  return (
    <ContextualMenuColorFillOption className={className} id="sticker-color-option" label={window.i18next.t('pmwjs_color')} data={getColorFillData()} onClick={onClickHandler} />
  );
}
